module.exports = __webpack_public_path__ + "static/media/authBanner.8516f913.svg";